module.exports = __webpack_public_path__ + "static/media/pictoaccess-logo.609e9905.png";